module.exports = __webpack_public_path__ + "static/media/expImgBlack.b1b6eb9d.svg";